import React, {useState, useEffect} from 'react'
import axiosInstance from './../../http/axios';

import Toast from '../../toast';
import Header from './../header/Header';

import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"

import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import { Dialog, DialogTitle, Fab, TextField } from '@mui/material';
import DropdownMenu from '../dropdown_menu/DropdownMenu';
import {Pagination} from '@mui/material';
import AddRounded from '@mui/icons-material/AddRounded';
import { NavLink } from 'react-router-dom';
import Switch from '../switch/Switch';
import LinearWithValueLabel from '../linear_progress_with_label/LinearProgressWithLabel';

const FakeVideoLiveStreamList = () => {

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

    const [isSending, setIsSending] = useState(false);
    const [uploadingProgress, setUploadingProgress] = useState(false);
    const [formData, setFormData] = useState({
        userName: '',
        userId: '',
        chatGroupId: '',
        bannerFile: null,
        videoFile: null,
    })
    const onChange = (event)=>{
        const { value, name } = event.target;
        setFormData(pVal => {
             if(name.toLowerCase().indexOf("file") == -1){
                  return {
                       ...pVal,
                       [name]: value
                  };
             }
             else{
                  return {
                       ...pVal,
                       [name]: event.target.files[0]
                  };
             }
        });
        // console.log(formData);
   }

     const [data, setData] = useState([]);
     const [maxLength, setMaxDataLength] = useState(0);
     const [isCreateDialogOpen, setCreateDialogOpen] = useState(false);
     const [errorMessage, setErrorMessage] = useState(null);
     const tableHead = ["Banner", "User Name", "User ID", "Chat Group", "Enabled", "Created At", "Video"];

     const onPageChange = async (e, pageIndex) => {
          try {
               const params = new URLSearchParams();
               params.append("skip", 20 * (pageIndex-1));
               params.append("limit", 20);

               const res = await axiosInstance.get('admin/fake-live-video-stream-list', {
                    params: params
               });
               setErrorMessage(null);
               setData(res.data.data);
               setMaxDataLength(res.data.maxLength);
          } 
          catch (error) {
               setErrorMessage("Failed");
               console.log(error);
          }
     }

     useEffect(async ()=>{
          onPageChange(null, 1);
     }, []);

    const onSubmit = async ()=>{

        if(!formData.userName){
             Toast.error('Please enter user name');
             return;
        }
        else if(!formData.userId && formData.userId.length == 6){
             Toast.error('Please enter valid user id');
             return;
        }

        setIsSending(true)
        try {
             const rBody = new FormData();
             rBody.append('userId', formData.userId)
             rBody.append('userName', formData.userName)
             rBody.append('videoFile', formData.videoFile)
             rBody.append('chatGroupId', formData.chatGroupId.trim())
             rBody.append('bannerFile', formData.bannerFile)
             const res = await axiosInstance.post("admin/fake-live-video-stream", rBody, 
                  {
                       headers: { "Content-Type": "multipart/form-data" },
                       onUploadProgress: (event)=>{
                         if (event.lengthComputable) {
                              const progress = Math.round((event.loaded / event.total) * 100);
                              setUploadingProgress(progress);
                         }
                       }
                  }
             );
             setFormData({
                  userId: '',
                  userName: '',
                  videoFile: null,
                  chatGroupId: '',
                  bannerFile: null,
             })
             setCreateDialogOpen(false);
             Toast.success('Created');
             setIsSending(false);
             setUploadingProgress(0);
        } catch (error) {
             console.log(error);
             setIsSending(false);
             Toast.error('Failed.')
             setFormData({
                userId: '',
                userName: '',
                videoFile: null,
                chatGroupId: '',
                bannerFile: null,
           })
        }
    }

     return (
          <>
               <Header/>
               <div className="d-flex justify-content-between">
                    <div style={{height: '80px'}} className='d-flex align-items-center'>
                         {/* <IconButton onClick={()=>naviagte(-1)}><ArrowBackRounded/></IconButton> */}
                         <h5  style={{marginLeft: '10px', height: '100%', marginTop: '5px'}} className='d-flex align-items-center'>Fake Video Live Stream</h5>
                    </div>
                    <div className="d-flex align-items-center">
                         <div className='banner_create' onClick={()=> setCreateDialogOpen(true)}>
                              <AddRounded style={{color: '#fff'}}/>
                              <button>Create</button>
                         </div>
                    </div>
                    {/* <DropdownMenu items={["Active users", "Blocked users"]} onChange={(value, i)=> {
                              const status = i == 0 ? "active" : "blocked";
                              setUserAccountStatus(status);
                              onPageChange(null, 0, status);
                         }}/> */}
               </div>
               <div className="__table_root">
                    <table cellspacing="0" cellpadding="0" className="table">
                    <tr>
                         { tableHead.map((value, i)=> <th>{value}</th>) }
                    </tr>
                    { errorMessage ? null : ( data.length != 0 ? data.map((value, i)=> <Item data={value} position={i}/>) : null) }
                    </table>
                    { data.length != 0 ? null : <ErrorMessage message='Empty'/> }
                    { errorMessage ? <ErrorMessage message={errorMessage}/> : null }
                    <div className='d-flex justify-content-between'>
                    <div></div>
                         <Pagination onChange={onPageChange} count={maxLength != 0 ? ~~((maxLength/20)+1) : 0} shape="rounded" />
                    </div>
               </div>
               <Dialog
                open={isCreateDialogOpen}
                onClose={isSending?()=>{}:(b)=>setCreateDialogOpen(false)}>

                    <DialogTitle style={{width: "700px"}}>Create Fake Video Live Stream</DialogTitle>
                    {
                         isSending ? 
                         <div style={{marginLeft: '20px', marginBottom: '20px'}}>
                              <LinearWithValueLabel value={uploadingProgress} />
                         </div>
                         :
                         <>
                              <div>
                                   <TextField name='userName' value={formData.userName} onChange={onChange} style={{width: '90%', marginLeft: "20px", marginTop: '40px', color: 'red'}} fullWidth label="User Name" type="text" inputProps={{ maxLength: 80 }}/>
                                   <TextField name='userId'value={formData.userId} onChange={onChange} style={{width: '90%', marginLeft: "20px", marginTop: '20px'}} fullWidth label="User ID" type="text" />
                                   <TextField name='chatGroupId'value={formData.chatGroupId} onChange={onChange} style={{width: '90%', marginLeft: "20px", marginTop: '20px'}} fullWidth label="Chat Group ID" type="text" />
                                   
                                   <div style={{ width: '100%', marginLeft: '35px'}}>
                                        <div className='notification-import-image-root d-flex justify-content-center align-items-center' style={{marginTop: '20px'}}>
                                             { formData.bannerFile ? <img style={{height: '100%', width: '100%'}} src={URL.createObjectURL(formData.bannerFile)}/> : <div> <AddRounded /> Banner </div> }
                                        </div>
                                        <label htmlFor="upload-photo" style={{marginTop: '10px'}}>
                                             <input name="bannerFile" onChange={onChange} style={{ display: 'none' }} id="upload-photo" type="file" itemType='image/*' />
                                             <Fab color="primary" size="small" component="span" aria-label="add" variant="extended">
                                                       <AddRounded /> {formData.bannerFile ? "Change" : "Upload"}
                                             </Fab>
                                        </label>
                                   </div>
                                   <div style={{ width: '100%', marginLeft: '35px'}}>
                                        <div className='notification-import-image-root d-flex justify-content-center align-items-center' style={{marginTop: '20px'}}>
                                             { formData.videoFile ? <img style={{height: '100%', width: '60%'}} src="/video.png"/> : <div> <AddRounded /> Video </div> }
                                        </div>
                                        <label htmlFor="upload-video" style={{marginTop: '10px'}}>
                                             <input name="videoFile" onChange={onChange} style={{ display: 'none' }} id="upload-video" type="file" itemType='video/*' />
                                             <Fab color="primary" size="small" component="span" aria-label="add" variant="extended">
                                                       <AddRounded /> {formData.videoFile ? "Change" : "Upload"}
                                             </Fab>
                                        </label>
                                   </div>
                              </div>
                              <button onClick={onSubmit} style={{width: '90%', marginLeft: "20px", marginBottom: '20px', marginTop: '30px', cursor: isSending ? "progress" : 'pointer'}} className="__btn">Create</button>
                          </>
                    }
            </Dialog>
          </>
     );
}

const Item = (props) => {
     const { _id, banner, userName, userId, enabled, chatGroupId, chatGroupName, videoUrl, date } = props.data;

     const [checked, setChecked] = useState(enabled);
     const [isDeleted, setDeleted] = useState(false);

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const onCheckedChange = async (checked) => {
          setChecked(checked)
          try {
               const rBody = new FormData();
               rBody.append("id", _id)
               rBody.append("enabled", checked)
               const res = await axiosInstance.patch("admin/fake-live-video-stream-enable", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               )
          } 
          catch (error) {
               Toast.error("Failed to update");
               setChecked(!checked);
          }
     }

     useEffect(()=> {
          setChecked(enabled)
     }, [enabled]);

     const onDelete = async () => {
          setDeleted(true);
          try {
               const rBody = new FormData();
               rBody.append("id", _id)
               const res = await axiosInstance.post("admin/fake-live-video-stream-delete", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               )
          } 
          catch (error) {
               Toast.error("Failed to update");
               setDeleted(false);
          }
     }

     if(isDeleted) return null;

     return(
          <tr>
               <td><img src={banner} alt="banner" style={{borderRadius: '0px', width: '60px', height: '60px'}}/></td>
               <td>{userName}</td>
               <td>{userId}</td>
               <td>{chatGroupId?<a href={"/admin-fake-chat" + "?chatGroupId=" + chatGroupId} target='_blank'>{chatGroupName}</a> : "-- --"}</td>
               <td><Switch onChange={(checked)=>{onCheckedChange(checked)}} checked={checked} /></td>
               <td>{date}</td>
               <td><a target='_blank' href={videoUrl} style={{background: "green", border: "none", color: "white", padding: "5px 15px", borderRadius: "5px"}} >Preview</a></td>
               <td><button onClick={onDelete} style={{background: "red", border: "none", color: "white", padding: "5px 15px", borderRadius: "5px"}} >Delete</button></td>
          </tr>
     );
};

const ErrorMessage = (props) => {
     return (
          <div className='d-flex align-items-center justify-content-center' style={{height: "300px", fontSize: '16px'}}>
               {props.message}
          </div>
     );
}

export default FakeVideoLiveStreamList;